import { TreeSelect as AntTreeSelect } from "antd";
import { jsx as _jsx } from "react/jsx-runtime";
export const TreeSelect = props => {
    const { ...propsPropagate } = props;
    return /*#__PURE__*/ _jsx(AntTreeSelect, {
        ...propsPropagate
    });
};
